//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';
import MissionContent from './MissionContent';

import Heading from '../../Components/Heading';

import Brain_jpg from '../../Assets/v2/about/Brain.jpg';
import Nutshell_png from '../../Assets/v2/about/Nutshell.png';

import Brain_webp from '../../Assets/v2/about/Brain.webp';
import Nutshell_webp from '../../Assets/v2/about/Nutshell.webp';

import Brain_fallback from '../../Assets/fallbacks/about/Brain.jpg';
import Nutshell_fallback from '../../Assets/fallbacks/about/Nutshell.jpg';

const Mission = () => {
  const { t } = useTranslation();

  return (
    <div className="about-mission-container">
      <div className="mission-content">
        <Heading title={t('missionHeading')} />

        <MissionContent
          fallbackImage={Brain_fallback}
          webpImage={Brain_webp}
          image={Brain_jpg}
          title={t('mission1Title')}
          text={t('mission1Text')}
        />

        <MissionContent
          fallbackImage={Nutshell_fallback}
          webpImage={Nutshell_webp}
          image={Nutshell_png}
          title={t('mission2Title')}
          text={t('mission2Text')}
        />
      </div>
    </div>
  );
};

export default Mission;



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/Mission.js